import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import Header from './Header.jsx';
import SupportChat from './SupportChat.jsx';

export default function Layout() {
  // Sidebar collapses by default and expands on hover; the hamburger button
  // still toggles for users who prefer an explicit click.
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="min-h-screen bg-bg text-text-primary flex flex-col">
      <Header />
      <div className="flex-1 flex min-w-0 min-h-0">
        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed((c) => !c)}
          onHoverChange={(hovered) => setCollapsed(!hovered)}
        />
        <main className="flex-1 overflow-y-auto min-w-0">
          <div className="mx-auto w-full px-10 py-8 min-[1920px]:max-w-[1600px]">
            <Outlet />
          </div>
        </main>
      </div>
      <SupportChat />
    </div>
  );
}
